import { getCalculatedDataset } from 'helpers/dataset.helper/dataset.calc.helper'
import i18n from 'i18next'

export function getElplanBidSumDataset(datasets: Dataset[], amountOfBlockBids: number): Dataset {
  return getCalculatedDataset(datasets, getDatasetInstructionsForSumVolumeCalc(amountOfBlockBids))
}

export function getDatasetInstructionsForSumVolumeCalc(amountOfBlockBids: number): CalcDatasetInstruction {
  const volumeVariablesBids: string[] = []

  for (let i = 0; i < amountOfBlockBids; i++) {
    volumeVariablesBids.push(`blockbid.${i + 1}.volume`)
    volumeVariablesBids.push(`profilebid.${i + 1}.volume`)
  }
  return {
    type: 'calc',
    filter: {
      end_time: '$end_time',
      aggregate: '',
      start_time: '$start_time',
      zero_is_nan: true,
    },
    contract: {
      operator: '+',
      variables: [...volumeVariablesBids, 'spotbid_without_price.volume'],
      element_wise: true,
      accumulate: '',
    },
    return_id: 'sum_volume',
  }
}

export function getItemsForExcel(amountOfBlockBids: number): { data_id: string; title: string }[] {
  const volumeBids: { data_id: string; title: string }[] = []
  const priceBids: { data_id: string; title: string }[] = []

  for (let i = 0; i < amountOfBlockBids; i++) {
    volumeBids.push({ data_id: `blockbid.${i + 1}.volume`, title: `${i18n.t('Block bid')} ${i + 1}` })
    volumeBids.push({ data_id: `profilebid.${i + 1}.volume`, title: `${i18n.t('Profile bid')} ${i + 1}` })
    priceBids.push({ data_id: `blockbid.${i + 1}.price`, title: `${i18n.t('Block bid')} ${i + 1}` })
    priceBids.push({ data_id: `profilebid.${i + 1}.price`, title: `${i18n.t('Profile bid')} ${i + 1}` })
  }
  return [{ data_id: 'spotbid_without_price.volume', title: 'Spotbud' }, ...volumeBids, ...priceBids]
}
